module.exports = __webpack_public_path__ + "img/pic-logo-xtia.9bd355d6.png";